import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { toastrMessage } from "helpers/messageHelper";
import {
  formatAddress,
  formatDate,
  formatDateTime,
} from "helpers/generalUtils";
import { SUCCESS, DANGER } from "constants/commonConstants";
import moment from "moment";

import { getProductSlipListRequest } from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { makeProductSlipSelectField } from "store/ProductSlip/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import ProductSlipStatus from "./ProductSlipStatus";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Product Slip number",
    field: "productSlipNo",
  },
  {
    label: "Date",
    field: "createdDate",
  },
  {
    label: "Username",
    field: "username",
  },
  {
    label: "Billing Address",
    field: "userAddress",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class ProductSlipList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productSlipRecords: [],
      startDate: formatDate(moment(new Date()).subtract(1, "months")),
      endDate: formatDate(new Date()),
    };
  }

  componentDidMount() {
    //Retrieve order list
    this.props.getProductSlipListRequest({
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
    });
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.productSlipData !== nextprops.productSlipData) {
      this.buildOrderDataTable(nextprops.productSlipData);
    }
    if (
      this.props.productSlipApiResponse !== nextprops.productSlipApiResponse
    ) {
      if (nextprops.productSlipApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.productSlipApiResponse.responseMessage,
          SUCCESS
        );
        this.props.getProductSlipListRequest({
          fromDate: this.state.startDate,
          toDate: this.state.endDate,
        });
        this.props.closeModal();
      } else if (!nextprops.productSlipApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.productSlipApiResponse.responseMessage, DANGER);
      }
    }
  }

  buildOrderDataTable = (records) => {
    this.setState({
      productSlipRecords: records.map((productSlip) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-eye fa-lg"
              onClick={this.viewProductSlip(productSlip)}
              tooltip={"View"}
            />
          </div>
        );

        let status = (
          <ProductSlipStatus
            status={productSlip.productSlipStatus}
            productSlipId={productSlip.productSlipId}
          />
        );
        let userAddress = formatAddress(productSlip.userAddress);

        return {
          productSlipNo: productSlip.productSlipNo,
          createdDate: formatDateTime(productSlip.createdDate),
          username: productSlip.username,
          userAddress: userAddress,
          status: status,
          actions: actions,
        };
      }),
    });
  };

  viewProductSlip = (productSlipData) => () => {
    this.props.onViewProductSlip(productSlipData);
  };

  onChangeStartDate = (e) => {
    const date = e.target.value;
    // if end date is less than start date
    if (new Date(this.state.endDate) < new Date(date)) {
      this.setState({ startDate: date, endDate: date });
    } else this.setState({ startDate: date });
  };

  onChangeEndDate = (e) => {
    const date = e.target.value;
    // if end date is less than start date
    if (new Date(this.state.startDate) > new Date(date)) {
      this.setState({ startDate: date, endDate: date });
    } else this.setState({ endDate: date });
  };

  findProductSlipFilter = () => {
    this.props.getProductSlipListRequest({
      fromDate: this.state.startDate,
      toDate: this.state.endDate,
    });
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.productSlipRecords,
    };

    return (
      <React.Fragment>
        <Row className="form-group my-2">
          <label className="col-4 col-md-2 col-lg-2 col-form-label">
            Start Date:
          </label>
          <Col xs="8" md="4" lg="3" className="my-2">
            <input
              type="date"
              onChange={this.onChangeStartDate}
              value={this.state.startDate}
              className="form-control"
            />
          </Col>
          <label className="col-4 col-md-2 col-lg-2 col-form-label">
            End Date:
          </label>
          <Col xs="8" md="4" lg="3" className="my-2">
            <input
              type="date"
              onChange={this.onChangeEndDate}
              value={this.state.endDate}
              className="form-control"
            />
          </Col>
          <Col xs="12" lg="2" className="my-2">
            <button
              className="btn btn-primary float-right"
              onClick={this.findProductSlipFilter}
            >
              Find Slips
            </button>
          </Col>
        </Row>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productSlipData: makeProductSlipSelectField("productSlipData"),
  productSlipApiResponse: makeProductSlipSelectField("productSlipApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getProductSlipListRequest,
});

export default compose(withConnect, withRouter)(ProductSlipList);
